export const ShippingInformation = () => {
  return (
    <div
      className="modal fade"
      id="shippingMethod"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-animate-center shipping-method-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">
              Shipping Information
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <div className="shipping-information">
              <h6>Express Shipping</h6>
              <ul>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    Delivery to capital cities and major centers the next
                    working day.
                  </span>
                </li>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    Remote locations delivered USUALLY WITHIN 2 – 3 WORKING
                    DAYS, (Excluding Public Holidays) Cut off at 3:00 PM EST
                    Sydney time. Order before 3:00 PM EST for Same Day Despatch
                  </span>
                </li>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    PO Box, Parcel Lockers will incur an additional charge
                    Transport companies used will be At our discretion. E.g.
                    Toll Priority, Startrack Premium, Express Post.
                  </span>
                </li>
              </ul>
              <p>
                <b>Note.</b> Express service is not a guaranteed service and
                delivery times are beyond our control. Express service is not
                available for dangerous goods.
              </p>
            </div>
            <div className="shipping-information">
              <h6>Standard Shipping</h6>
              <ul>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>Standard Shipping.</span>
                </li>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    Bulky Products and delivery to Remote / Special areas may
                    incur additional charges. PO Box, Parcel Lockers will incur
                    an additional charge
                  </span>
                </li>
              </ul>
            </div>
            <div className="shipping-information">
              <h6>Mail</h6>
              <ul>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>Goods will be sent using Standard Mail Service.</span>
                </li>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    Dangerous goods cannot be sent by mail, road service only.
                    Only available for items under 500 grams including
                    packaging.
                  </span>
                </li>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    Only available for items under 500 grams including
                    packaging.
                  </span>
                </li>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    Parcels over 500 grams will be sent in the most economical
                    way.
                  </span>
                </li>
              </ul>
            </div>
            <div className="shipping-information">
              <h6>Courier Pick Up</h6>
              <ul>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    You will need to organise your own courier to pick up the
                    parcel from us.
                  </span>
                </li>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    Please provide details of the courier company who will be
                    picking up the order in the order comments before submitting
                    the order.
                  </span>
                </li>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    Goods will be packaged with an invoice included with the
                    Parcel
                  </span>
                </li>
              </ul>
            </div>
            <div className="shipping-information">
              <h6>Shop Counter Pick Up</h6>
              <ul>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    You or your company representative will pick up the goods
                    from our Trade Counter.
                  </span>
                </li>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    Invoice will be supplied at pick up. SMS or/and E-Mail
                    notifications will be sent once the order is ready to be
                    collected in-store.
                  </span>
                </li>
              </ul>
            </div>
            <div className="shipping-information">
              <h6>Drop Shipment</h6>
              <ul>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>We will send goods directly to your customer.</span>
                </li>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    No invoice will be enclosed in the Parcel. Picking slip
                    included with the order only.
                  </span>
                </li>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>The invoice will be sent to you by email.</span>
                </li>
              </ul>
            </div>
            <div className="shipping-information">
              <h6>Shipping Cost</h6>
              <ul>
                <li>
                  <i className="fa-solid fa-circle" />{" "}
                  <span>
                    Shipping costs will be calculated and shown at check out.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
